<template>
  <div>
    <v-app>
      <resizable-page>
        <template v-slot:table="tableProps">
          <v-card>
            <v-card-title>
              <v-btn
                color="primary"
                dark
                class="ma-2"
                @click="addData"
                v-if="role.create"
              >
                Add Gate Pass
              </v-btn>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Export To XLS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <downloadExcel
                      class = "btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch= "()=>{return dataExportBefore('all')}"
                      
                    >
                      All Record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item>
                    <downloadExcel
                      class = "btn"
                      :data="exportDisplayedPage"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                    >
                      Displayed record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item>
                    <downloadExcel
                      class = "btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch= "()=>{return dataExportBefore('filter')}"
                    >
                      All filtered record
                    </downloadExcel>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>
              <div class="d-flex">
                <v-select
                  style=" max-width: 150px;"
                  :items="option_filter"
                  label="Select"
                  v-model="searchCategory"
                  @change="search=''"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
                <v-text-field
                  :disabled="!searchCategory"
                  v-model="search"
                  label="Search"
                    class="ma-2"
                  single-line
                  hide-details
                >
                </v-text-field>
                <v-btn :disabled="!search" class="mt-5"  small color="primary" @click="searchButton"> <v-icon>mdi-magnify</v-icon> </v-btn>
                <v-btn v-if="searchValue" class="mt-5 ml-1" dark small color="red" @click="clearSearchButton">Clear</v-btn>
              </div>
            </v-card-title>
            <v-data-table
              mobile-breakpoint
              :headers="headers"
              :items="table"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              :height="tableProps.tableHeight"
              fixed-header
              :options.sync="options"
              :server-items-length="totalDataTable"
              :page="page"
              :pageCount="numberOfPages"
              :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
            >
            
              <template v-slot:[`item.detail`]="{ item }">
                <router-link :to="{name: 'Detail Gate Pass', params: { id: item.id }}" class="btn btn-primary">Detail
                </router-link>
              </template>
              
              <template v-slot:[`item.vehicle_plate_no`]="{ item }">
                {{ item.gate_pass_vehicle.vehicle_plate_no }}
              </template>
              <template v-slot:[`item.vehicle_chassis_no`]="{ item }">
                {{ item.gate_pass_vehicle.vehicle_chassis_no }}
              </template>



              <template v-slot:[`item.actions`]="{ item }">
                
                  <v-menu  offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="detailGatePass(item.id)">
                      <v-list-item-title >Detail</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="role.update" @click="editData(item.id)">
                      <v-list-item-title x-small>Edit</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              
            </v-data-table>
          </v-card>
        </template>
      </resizable-page>
    </v-app>
    <modal ref="modalAddPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>ADD GATE PASS</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseAdd()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <add-gate-pass />
      </template>
    </modal>

    <modal ref="modalEditPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>EDIT GATE PASS</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseEdit()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <edit-gate-pass :data_id="$refs.modalEditPage.data" />
      </template>
    </modal>
    <!-- <modal ref="modalDetailPage">
      <template v-slot:body>
        <detail-gate-pass :data_id="$refs.modalDetailPage.data" />
      </template>
    </modal> -->
  </div>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";
import { ResizablePage } from "@/components";
import addGatePass from "@/pages/Dashboard/Workshop/GatePass/AddGPPage.vue";
import editGatePass from "@/pages/Dashboard/Workshop/GatePass/EditGPPage.vue";
// import detailGatePass from "@/pages/Dashboard/Workshop/GatePass/DetailGPPage.vue";
import { Modal } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage, Modal, "add-gate-pass" : addGatePass, "edit-gate-pass" : editGatePass
  },
    vuetify,
    data () {
      return {
        searchValue:null,
        searchCategory:null,
        option_filter: [ 
          { text: 'Gate Pass No', value: 'gate_pass_no'},
          { text: 'Handover to', value: 'gate_pass_applicant_name'},
          { text: 'Purpose', value: 'gate_pass_purpose'},
          { text: 'Start Date', value: 'gate_pass_start_date'},
          { text: 'Plate No', value: 'vehicle_plate_no'},
          { text: 'Vin No', value: 'vehicle_chassis_no'},
          ],
        page: 1,
        totalDataTable: 0,
        numberOfPages: 0,
        loadTable: true,
        role: "",
        search: '',
        options: {},
        headers: [
          // {
          //   text: 'Detail',
          //   align: 'start',
          //   value: 'detail',
          //   sortable : false
          // },
          { text: 'Actions', value: 'actions', align: 'center', sortable: false },
          { text: 'Gate Pass No', value: 'gate_pass_no'},
          { text: 'Handover to', value: 'gate_pass_applicant_name'},
          { text: 'Purpose', value: 'gate_pass_purpose'},
          { text: 'Start Date', value: 'gate_pass_start_date'},
          { text: 'Plate No', value: 'vehicle_plate_no'},
          { text: 'Vin No', value: 'vehicle_chassis_no'},
        ],
        table: [],
        worksheetName: "test",
        fileName:"test.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        exportAll:[],
        field_export: {
         'gate_pass_no': 'gate_pass_no',
         'gate_pass_applicant_name': 'gate_pass_applicant_name',
         'gate_pass_purpose': 'gate_pass_purpose',
         'gate_pass_start_date': 'gate_pass_start_date',
        'created_at' : 'created_at',
        'updated_at' : 'updated_at'
        },
      }
    },
    
    watch: {
    options: {
      handler() {
        if( !this.mounted){
          this.getList();
        }
      },
    },
    deep: true,
  },
    async mounted() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
      
    this.getList();
    this.mounted = false
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {
      this.loadTable= true
      const { page, itemsPerPage,sortBy,sortDesc } = this.options;
      console.log(this.options)
      let pageNumber = page;
      
      
      var query = {"page":{number:pageNumber,size:itemsPerPage}}

      if(sortBy.length!=0){
        var  sort=sortBy[0]
        if(sortDesc[0]){
          sort="-"+sortBy[0]
        }
        query.sort = sort
      }

      if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }
    
      await this.$store.dispatch("workshop_gate_pass/list",query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
        this.table = await this.$store.getters["workshop_gate_pass/list"];
        var pageMeta  = await this.$store.getters["workshop_gate_pass/page"];
      // }
      // else{
      //   this.table = []
      // }
      console.log(pageMeta)
      this.totalDataTable = pageMeta.total
      this.numberOfPages = pageMeta['to']
      this.loadTable= false
    },
    searchButton(){
       this.options.page = 1;
      this.searchValue = this.search
      this.getList()
    },
    clearSearchButton(){
       this.options.page = 1;
      this.searchValue = null
      this.search = null
      this.searchCategory = null
      this.getList()
    },


    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    // if(this.$refs.vTable){
    //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    // }
    // else{
    //   this.exportAllFitered = this.dataExport(this.table)
    // }
    },

    async dataExportBefore(type){
      if(this.table.length!=0){
        
      console.log("ewww")
        if(type=="all"){
          await this.$store.dispatch("workshop_gate_pass/list");
          return this.dataExport(await this.$store.getters["workshop_gate_pass/list"]);
        }
        else if(type=="filter"){

          var query = {}

           if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }
          
            await this.$store.dispatch("workshop_gate_pass/list",query);
             return this.dataExport(await this.$store.getters["workshop_gate_pass/list"]);
        }
      }
      
    },

     
    addData() {
      this.$refs.modalAddPage.openModal();
    },

    modalCloseAdd() {
      this.$refs.modalAddPage.closeModal();
      this.getList();
    },

    editData(id) {
      this.$refs.modalEditPage.openModal({ id: id });
    },

    modalCloseEdit() {
      this.$refs.modalEditPage.closeModal();
      this.getList();
    },

    detailGatePass(id) {
      // panggil add page
     this.$router.push({name: 'Detail Gate Pass', params: { id:id }});
    },

    // detailGatePass(id){
    //   this.$refs.modalDetailPage.openModal({ id: id });
    // },

    // modalCloseDetail() {
    //   this.$refs.modalDetailPage.closeModal();
    //   this.getList();
    // },

    // // fungsi tombol direct ke edit page
    // editData(id) {
    //   // panggil edit page
    //   this.$router.push({ name: 'Edit Gate Pass', params: { id: id } })
    // },

  
    // // validasi delete data
    // deleteConfirmation(id) {
    //   Swal.fire({
    //     title: "Are you sure?",
    //     text: "You wont be able to revert this!",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Yes, delete it!",
    //     cancelButtonText: "No, cancel!",
    //     buttonsStyling: true,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.deleteData(id);
    //     }
    //   });
    // },

    //  // fungsi delete
    // async deleteData(id) {
    //   try {
    //     // kirim data ke api
    //     await this.$store.dispatch("workshop_gate_pass/destroy", id)
    //     // panggil alert success
    //     await this.$store.dispatch("alerts/success", "test data delete successfully.")
    //     //await this.getList();
    //     var indexOptionTable = this.table.findIndex(p => p.id ==  id)
    //        this.table.splice(indexOptionTable, 1)
    //   } catch (e) {
    //     // panggil alert error
    //     await this.$store.dispatch(
    //       "alerts/error",
    //       "Oops, something went wrong!"
    //     );
    //   }
    // },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
      dataExport(data){
       return data.map((v,index) => ({...v, no: index+1}))
      
     
      }
     },
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>
